import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_RECENT_POSTS } from '../../graphql/queries';

const EditorsPicks = () => {
    const publicUrl = process.env.PUBLIC_URL + '/';

    // Fetch 4 posts for Editor's Picks
    const { data, loading, error } = useQuery(GET_RECENT_POSTS, {
        variables: { first: 4 }
    });

    // Strictly limit to 4 posts
    const allPosts = data?.posts?.nodes || [];
    const posts = allPosts.slice(0, 4);

    console.log('Editor\'s Picks - Total posts from query:', allPosts.length);
    console.log('Editor\'s Picks - Posts being displayed:', posts.length);

    // Helper function to format date
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    };

    // Helper function to get excerpt
    const getExcerpt = (excerpt, maxLength = 120) => {
        if (!excerpt) return '';
        const text = excerpt.replace(/<[^>]*>/g, '');
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    };

    // Helper function to get featured image URL
    const getFeaturedImage = (post, index) => {
        return post?.featuredImage?.node?.sourceUrl || publicUrl + 'assets/img/post/' + (10 + index) + '.png';
    };

    // Helper function to get first category
    const getFirstCategory = (post) => {
        return post?.categories?.nodes?.[0] || { name: 'Uncategorized', slug: 'uncategorized' };
    };

    if (loading) {
        return (
            <div className="bg-sky pd-top-80 pd-bottom-50">
                <div className="container">
                    <div className="section-title">
                        <h6 className="title">Editor's Picks</h6>
                    </div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <p>Loading...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        console.error('EditorsPicks Error:', error);
        return null;
    }

    return (
        <div className="bg-sky pd-top-75 pd-bottom-50">
            <div className="container">
                <div className="section-title">
                    <h6 className="title">Editor's Picks</h6>
                </div>
                <div className="row">
                    {posts.map((post, index) => {
                        return (
                            <div className="col-lg-3 col-sm-6" key={post.id}>
                                <div className="single-post-wrap">
                                    <div className="thumb">
                                        <img
                                            src={getFeaturedImage(post, index)}
                                            alt={post?.featuredImage?.node?.altText || post.title}
                                        />
                                    </div>
                                    <div className="details">
                                        <h6 className="title">
                                            <Link
                                                to={'/blog/' + post.slug}
                                                dangerouslySetInnerHTML={{ __html: post.title }}
                                            />
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default EditorsPicks;
